import index from './index';

export default index;
